import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { GvpVideoComponent } from 'lib/ng2-sapmp/src/ui-components/gvp-video';
import { LearnService } from './shared/';

import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { TabModel, TabComponent } from 'lib/ng2-sapmp/src/ui-components/tab';
import { BREADCRUMBS, ADDP_PERMISSION_MAPPING, ADDP_PERMISSION_MAPPING_FNABC } from 'config';

export const ESCAPE_KEY = 27;
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss'],
  providers: [LearnService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})
export class LearnComponent implements OnInit, AfterViewInit {
  learn: any;
  tabDetails: Array<TabModel>;
  showTab: Boolean;
  user: any;
  permissions: any;
  initModal: any;
  showOverviewModal: boolean;
  permissionLevelMessage: string;
  overviewModalPopup: ConfirmModalPopupModel;
  eventEmit: any;
  modalClass: string;
  videoId: string;
  focusabbleElements: any;
  loginSwitch: boolean = false;

  @ViewChild('accessModal') accessModal: ElementRef;
  constructor(private route: ActivatedRoute, private router: Router, private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService,
    private learnService: LearnService, private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService, private changeDetectionRef: ChangeDetectorRef, private breadCrumbService: BreadCrumbService,
    private el: ElementRef) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.permissionLevelMessage = null;
    this.initModal = false;
    this.showOverviewModal = false;
    this.showTab = false;
    this.tabDetails = [];
    this.initOverviewModal();
  }

  ngOnInit() {
    // this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.pageloaderService.setPageLoaderStatus(false);
    this.learnService.getLearnPage(this.utilityService.getEnvConfig().learnPageUrl)
      .subscribe(response => {
        this.learn = response;
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device management program', routerLink: '/learn' });
        this.pageloaderService.setPageLoaderStatus(true);
        ({ 'modalRedirect': this.initModal } = this.route.snapshot.queryParams);
        setTimeout(() => { this.loadFocustelements(this.accessModal.nativeElement); });
        if (this.initModal === 'true') {
          this.learnService.createPageLoadProperties('ELIGIBILITYMODAL');
        }
        this.tabDetails = this.learn.template;
        this.showTab = true;
        this.changeDetectionRef.detectChanges();
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    const pageName = 'learnPage';
    // this.learnService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument, pageName).
    //   subscribe(res => {
    //     this.videoId = res.supportArticles.availableArticle[0].url;
    //   });
    this.learnService.createPageLoadProperties('LEARN');
  }

  handleError(error) {
    throw error;
  }

  ngAfterViewInit() {
    this.user = this.authenticationService.getUser();
    this.permissions = this.authenticationService.getPermissions();
    if(this.user && this.permissions) {
      const perMapping = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
      if( ENV_PORTAL === 'fnabc' ){
        this.permissionLevelMessage = ADDP_PERMISSION_MAPPING_FNABC[perMapping].message;
      }else{
        this.permissionLevelMessage = ADDP_PERMISSION_MAPPING[perMapping].message;
      }
    }
  }

  closeModal() {
    this.initModal = false;
    setTimeout( () => {
      this.loadFocustelements(document)
    },0);
    this.learnService.createPageLoadProperties('LEARN');
  }

  initOverviewModal() {
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.overviewModalPopup.modalMessage = '';
    this.overviewModalPopup.modalSubHeader = 'Overview Tutorial';
    this.overviewModalPopup.modalHeader = 'Modal Header';
    this.overviewModalPopup.confirmButtonMessage = 'OK';
    this.overviewModalPopup.showCancelButton = false;
    this.modalClass = 'modal-lg';
  }

  openOverviewModal() {
    this.showOverviewModal = true;
    this.eventEmit = document.activeElement;
    this.learnService.createPageLoadProperties('ELIGIBILITYMODAL');
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
    this.learnService.createPageLoadProperties('LEARN');

  }

  loadFocustelements(el) {
    if (!this.focusabbleElements) {
      const focusableEls = el.
        querySelectorAll('a[href], area[href],' +
          ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

  btnAction(event) {
    this.focusabbleElements = undefined;
    this.closeModal();
    if (event.target) {
      event.target.focus();
    }
  }

  handleKeydown(event) {
    if (event.keyCode === ESCAPE_KEY) {
      this.btnAction(false);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  checkEligibility() {
    sessionStorage.setItem('eligibilityCheck', 'true');
    this.adobeAnalyticsService.createClickProperties('Check eligibility', 'Body', '/businessconsole/login');
    this.loginSwitch = JSON.parse(sessionStorage.getItem('loginDropdownPopupSwitch'));
    if( this.loginSwitch ){
      this.authenticationService.setLoginModalStatus(true);
    } else{
      this.router.navigate(['login']);
    }
  }
  adobeLinkClick() {
    this.adobeAnalyticsService.createClickProperties('Overview tutorial', 'Body', '/businessconsole/learn');
  }
  getStarted(link){
    this.router.navigate(['manageInventory']);
  }
}
